import { Box } from "@material-ui/core";
import FavoritesList from "./FavoritesList";

const FavoritesPage = () => {
  return (
    <Box width="100%">
      <FavoritesList></FavoritesList>
    </Box>
  );
};

export default FavoritesPage;
